import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    CentreCode: { label: i18n.t('administrativecenter.CentreCode'), value: '' },
    RoleCode: { label: i18n.t('administrativecenter.RoleTypeCode'), value: '' },
    Name: { label: i18n.t('app.name'), value: '' },
    FirstSurname: { label: i18n.t('persons_data.firstsurname'), value: '' },
    SecondSurname: { label: i18n.t('persons_data.secondsurname'), value: '' },
    Address: { label: i18n.t('address.location'), value: '' },
    PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
    Town: { label: i18n.t('address.poblacion'), value: '' },
    Province: { label: i18n.t('address.provincia'), value: '' },
    CountryCode: { label: i18n.t('address.pais'), value: '' },
    Telephone: { label: i18n.t('address.telefono'), value: '' },
    TeleFax: { label: i18n.t('administrativecenter.telefax'), value: '' },
    WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
    ElectronicMail: { label: i18n.t('contacto.ElectronicMail'), value: '' },
    ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
    CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
    INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
    AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
    PhysicalIGLN: { label: i18n.t('administrativecenter.PhysicalGLN'), value: '' },
    LogicalOperationalPoint: { label: i18n.t('administrativecenter.LogicalOperationalPoint'), value: '' },
    CentreDescription: { label: i18n.t('administrativecenter.CentreDescription'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'selected', width: '50px', headerSelectionValue: false, locked: true, lockable: false, columnMenu: false, reorderable: false, groupable: false },
    { field: 'CentreCode', title: i18n.t('administrativecenter.CentreCode'), columnMenu: 'myTemplate', width: '300px', locked: false },
    { field: 'RoleCode', title: i18n.t('administrativecenter.RoleTypeCode'), format: 'TIPOS_ROL_ADMINISTRATIVE_CENTER', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '130px', locked: false },
    { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '130px', locked: false },
    { field: 'FirstSurname', title: i18n.t('persons_data.firstsurname'), columnMenu: 'myTemplate', width: '180px', locked: false },
    { field: 'SecondSurname', title: i18n.t('persons_data.secondsurname'), columnMenu: 'myTemplate', width: '180px', locked: false },
    { field: 'Address.Address', width: '150px', title: i18n.t('address.location'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.PostCode', width: '160px', title: i18n.t('address.codigo_postal'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.Town', width: '130px', title: i18n.t('address.poblacion'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.Province', width: '140px', title: i18n.t('address.provincia'), columnMenu: 'myTemplate', locked: false },
    { field: 'Address.CountryCode', width: '120px', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.Telephone', width: '150px', title: i18n.t('address.telefono'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.TeleFax', width: '170px', title: i18n.t('administrativecenter.telefax'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.WebAddress', width: '150px', title: i18n.t('contacto.WebAddress'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.ElectronicMail', width: '200px', title: i18n.t('contacto.ElectronicMail'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.ContactPersons', width: '150px', title: i18n.t('contacto.entity_name_plural'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.CnoCnae', width: '160px', title: i18n.t('administrativecenter.cno_cnae'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.INETownCode', width: '200px', title: i18n.t('administrativecenter.INE_town_code'), columnMenu: 'myTemplate', locked: false },
    { field: 'ContactDetails.AdditionalDetails', width: '210px', title: i18n.t('administrativecenter.additional_details'), columnMenu: 'myTemplate', locked: false },
    { field: 'PhysicalIGLN', width: '200px', title: i18n.t('administrativecenter.PhysicalGLN'), columnMenu: 'myTemplate', locked: false },
    { field: 'LogicalOperationalPoint', width: '300px', title: i18n.t('administrativecenter.LogicalOperationalPoint'), columnMenu: 'myTemplate', locked: false },
    { field: 'CentreDescription', width: '260px', title: i18n.t('administrativecenter.CentreDescription'), columnMenu: 'myTemplate', locked: false },
    { field: 'IdAdministrativeCentre', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '70px', locked: false },
  ]
}

const getDefaultState = () => {
  return {
    notificationsNumber: {},
  }
}
const customState = getDefaultState()
const customGetters = {
  getNotificationsNumber: state => state.notificationsNumber,
}
const customMutations = {
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber (state) {
    state.notificationsNumber = {}
  },
}

const mystore = parent({ customState, customGetters, customMutations, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
